import translates from './ru.json';
import restNotifications from './notifiers.json';

export default {
  ru: { ...translates, ...restNotifications },
};
